<template>

  <div class="container">

     

            <ErrorAlert v-if="msg" :msg="msg"></ErrorAlert>
       

       <form id="login-form" class="form-signin" >

           <img id="logo" src="../assets/images/SPARK-logo-big.png" style="width: 100% !important;"/>

           <h4 class="form-signin-heading">Login</h4>

           <input type="text" name="username" class="form-control top-input" placeholder="Username" required autofocus>

           <input type="password" name="password" class="form-control bottom-input" placeholder="Password" autocomplete="off" required>

           <button class="btn btn-lg btn-primary btn-block" type="button" @click="sendform()">Sign in</button>

        </form>

               </div>

              

</template>

 

<script>

/* eslint-disable */

import axios from 'axios';

//import router from '@/router';

import ErrorAlert from './ErrorAlert.vue';

//import loginService from '../services/loginService.js'

//import store from '@/store/index.js'

export default {

  name: 'LoginComponent',

  //props: {

  //  msg: String

  //}

  components:  {

    ErrorAlert

  },

  data: function () {

    return {

      user: null,

      username: null,

      esito: { check: false, message: null },

      msg: null,

    };

  },

  mounted() {
    let customScript2 = document.createElement('script')

    customScript2.setAttribute('src', '/scripts/utils.js')

    customScript2.setAttribute('type', 'application/javascript')

    document.head.appendChild(customScript2)
  

  },

  methods: {

   sendform() {

      sessionStorage.setItem("reload-needed-dashboard", "true")

      const me = this;

      const UNATOHORIZED = 401;

      const endpoint = baseUrl + "/api/esegui-login";

      const method = "POST";

      const headers = { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' , 'CrossDomain': true,  'Accept': 'application/json' };

      const form = document.querySelector("#login-form");

      //form.

      const myFormData = new FormData(form);

      const formDataObj = {};

      myFormData.forEach((value, key) => (formDataObj[key] = value));

      const passEncoded  = me.encode(formDataObj.password);

      formDataObj.password = passEncoded;

      console.log(passEncoded);

      var send_data = formDataObj;

    

      axios.post(endpoint,send_data, headers)

      .then((response) =>  {

         

          this.user =  response.data;

          this.username = this.user.username;

          this.esito = this.user.esito;

          if (UNATOHORIZED==this.esito.message.substring(0,3)) {

             this.msg ="NON AUTORIZZATO!!";

             this.$router.push("/login");

             return;

          }

          else {
            // TODO Gestione dei menu spalla sinistra
            this.msg = null;

            window.sessionStorage.setItem("user", JSON.stringify(this.user));

            const admin_phishing_true = this.user.role=='Admin' && this.user.phishing==true;
            const admin_phishing_false = this.user.role=='Admin' && this.user.phishing==false;
            const user_phishing_true = this.user.role=='User' && this.user.phishing==true; 
            const user_phishing_false = this.user.role=='User' && this.user.phishing==false;
            const reader_phishing_true = this.user.role=='Reader' && this.user.phishing==true; 
            const reader_phishing_false = this.user.role=='Reader' && this.user.phishing==false;

            const admin_usb_true = this.user.role=='Admin' && this.user.usb==true;
            const admin_usb_false = this.user.role=='Admin' && this.user.usb==false;
            const user_usb_true = this.user.role=='User' && this.user.usb==true;
            const user_usb_false = this.user.role=='User' && this.user.usb==false;
            const reader_usb_true = this.user.role=='Reader' && this.user.usb==true;
            const reader_usb_false = this.user.role=='Reader' && this.user.usb==false;

            const admin_quishing_true = this.user.role=='Admin' && this.user.quishing==true;
            const admin_quishing_false = this.user.role=='Admin' && this.user.quishing==false;
            const user_quishing_true = this.user.role=='User' && this.user.quishing==true;
            const user_quishing_false = this.user.role=='User' && this.user.quishing==false;
            const reader_quishing_true = this.user.role=='Reader' && this.user.quishing==true;
            const reader_quishing_false = this.user.role=='Reader' && this.user.quishing==false;


            
            if (admin_usb_true && admin_phishing_false && admin_quishing_false ) {
              this.$router.push("/dashboardUsb");
            }
            else if(admin_usb_true && admin_phishing_true ) {
              this.$router.push("/dashboard");
            }
            else if (admin_usb_false && admin_phishing_true ) {
              this.$router.push("/dashboard");
            }
            else if (admin_usb_true) {
              this.$router.push("/dashboardUsb");
            }
            else if (user_usb_true && user_phishing_false && user_quishing_true) {
               this.$router.push("/dashboardUsb"); 
            }
            else if (user_usb_true && user_phishing_false && user_quishing_false) {
              this.$router.push("/dashboardUsb");
            }
            else if(user_usb_true && user_phishing_true) {
              this.$router.push("/dashboard");
            }
            else if (user_usb_false && user_phishing_true) {
              this.$router.push("/dashboard");
            }
            else if (user_usb_true) {
              this.$router.push("/dashboardUsb"); 
            }
            else if (reader_usb_true && reader_phishing_false &&  reader_quishing_false ) {
                this.$router.push("/dashboardUsb");
            }
            else if(reader_usb_true && reader_phishing_true ) {
              this.$router.push("/dashboard");
            }
            else if (reader_usb_false && reader_phishing_true ) {
              this.$router.push("/dashboard");
            }
            else  if (reader_usb_true) {
              this.$router.push("/dashboardUsb");
            }
            else {
              this.$router.push("/dashboard");
            }      

          }

         

      })

      .catch((e) => {

            this.msg =e;

            this.$router.push({name: 'login'});

            //return;

      })

     

    },

    encode(string) {

        console.log(string + ' ' + btoa(string))

        return btoa(string);

    }

              

  }

}

 

 

 

 

 

</script>

 

<style></style>